import React, { Component } from "react";
import { constants } from "../../Constants";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Spring } from "react-spring";
import Swal from "sweetalert2";
import { validationEmail } from "../../helpers/response";
import {
  CounsellorsActions,
  alertActions,
  WhitelabelActions,
  LanguagesActions,
} from "../../store/actions";
import { history } from "../../helpers";
import Loading from "../../components/Loading/Loading";
import HeaderComponent from "../../components/Header";
import Footer from "../../components/Footer/footer";
import "../../static/css/styles.css";
import Select from "react-select";
import { languages } from "../../store/reducers/languages.reducer";
import { serviceTypeActions } from "../../store/actions/serviceType.actions";
import { validateImageFileType } from "../../helpers/utils";

class CreateCounsellor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initialCounsellor: null,
      name: "",
      error_name: "",
      domain: "",
      email: "",
      error_email: "",
      phone: "",
      error_phone: "",
      qualifications: "",
      error_qualifications: "",
      focus: "",
      error_focus: "",
      projects: false,
      file: "",
      error_logo: "",
      price_usd: "",
      price_pkr: "",
      error_price_usd: "",
      error_price_pkr: "",
      projectsSelected: [],
      languagesSelected: [],
      serviceTypeSelected: {},
      error_projects: "",
      languages: [],
      serviceTypes : [],
      error_languages: "",
      error_service_type: "",
      mode: "create",
      password: "",
      error_password: "",
      city: "",
      error_city: "",
      selectedId: "",
      counsellor: [],
      loading: false,
    };
    this.changeHandler = this.changeHandler.bind(this);
    this.validate = this.validate.bind(this);
  }

  componentWillMount() {
    this.props.fetchWhitelabel();
    this.props.fetchLanguages();
    this.props.fetchServiceType()
  }

  toggleLoading = (status) => {
    this.setState({ loading: status });
  };
  componentDidMount() {
    if (this.props.languages && this.props.languages.languages)
      this.setState({ languages: this.props.languages.languages });

      if(this.props.serviceTypes && this.props.serviceTypes.serviceTypes){
        this.setState({serviceTypes: this.props.serviceTypes.serviceTypes})
      }
    if (
      this.props.counsellors &&
      this.props.selectedCounsellor &&
      this.props.selectedCounsellor !== ""
    ) {
      //edit
      const obj = this.props.counsellors.find(
        (c) =>
          c.counsellor_details.counsellor_id === this.props.selectedCounsellor
      );
      if (obj) {
        let projectsSelected = [];
        let languagesSelected = [];
        if (obj.project_details && obj.project_details.length > 0) {
          obj.project_details.map((p) => {
            return projectsSelected.push({ value: p.id, label: p.name });
          });
          if (this.props.languages.languages) {
            obj.counsellor_details.languages.map((p) => {
              const lang = this.props.languages.languages.filter(
                (l) => l.language === p
              )[0];
              return languagesSelected.push({
                value: lang.id,
                label: lang.language,
              });
            });
          }
        }
        this.setState({
          initialCounsellor: obj,
          selectedId: this.props.selectedCounsellor,
          name: obj.user_details.full_name,
          email: obj.user_details.email,
          phone: obj.counsellor_details.contact_number,
          qualifications: obj.counsellor_details.qualifications,
          focus: obj.counsellor_details.area_of_expertise,
          price_usd: obj.counsellor_details.price_usd,
          price_pkr: obj.counsellor_details.price_pkr,
          projectsSelected,
          languagesSelected,
          serviceTypeSelected: {
            value: obj.counsellor_details.service_type.id,
            label: obj.counsellor_details.service_type.name,
          },
          city: obj.counsellor_details.home_city,
          mode: "edit",
          loading: false,
          languages: this.props.languages.languages,
        });
      }
    }
  }
  componentWillReceiveProps(nextProps) {
    const { projects, languages } = this.state;
    if (!!nextProps && nextProps.serviceTypes && nextProps.serviceTypes.service_types){
      this.setState({serviceTypes: nextProps.serviceTypes.service_types})
    }
    if (!!nextProps && nextProps.languages && nextProps.languages.languages)
      this.setState({ languages: nextProps.languages.languages });

    if (!!nextProps && nextProps.whitelabel)
      if (projects !== nextProps.whitelabel) {
        this.setState({ projects: nextProps.whitelabel, loading: false });
      }

    if (!!nextProps && nextProps.counsellors) {
      const { counsellors } = this.state;
      if (counsellors !== nextProps.counsellors) {
        const obj = nextProps.counsellors.find(
          (c) =>
            c.counsellor_details.counsellor_id === this.props.selectedCounsellor
        );

        if (obj) {
          let projectsSelected = [];
          // let languagesSelected = [];
          if (obj.project_details && obj.project_details.length > 0) {
            obj.project_details.map((p) => {
              if(!p.is_deleted){
                return projectsSelected.push({ value: p.id, label: p.name });
              }
            });
          }
          this.setState({
            initialCounsellor: obj,
            selectedId: this.props.selectedCounsellor,
            name: obj.user_details.full_name,
            email: obj.user_details.email,
            phone: obj.counsellor_details.contact_number,
            qualifications: obj.counsellor_details.qualifications,
            focus: obj.counsellor_details.area_of_expertise,
            //projects: false,
            price_usd: obj.counsellor_details.price_usd,
            price_pkr: obj.counsellor_details.price_pkr,
            projectsSelected,
            // languagesSelected: languagesSelected !== [] ? languagesSelected : this.state.languagesSelected,
            city: obj.counsellor_details.home_city,
            mode: "edit",
            loading: false,
            counsellors: nextProps.counsellors,
          });
        } else
          this.setState({ counsellors: nextProps.counsellors, loading: false });
      }
    }
  }

  changeProjects = (projectsSelected) => {
    this.setState({ projectsSelected });
  };
  changeLanguages = (languagesSelected) => {
    this.setState({ languagesSelected });
  };
  changeServiceType = (serviceTypeSelected) => {
    this.setState({ serviceTypeSelected });
  };
  changeHandler = (e) => {
    const { name, value } = e.target;
    if (name === "file") {
      this.setState({ [name]: e.target.files[0] });
    } else {
      this.setState({ [name]: value });
    }
  };

  validate = () => {
    const urlRegex =
      /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
    const phoneRegex =
      /^[\(]?[\+]?(\d{2}|\d{3})[\)]?[\s]?((\d{6}|\d{8})|(\d{3}[\*\.\-\s]){3}|(\d{2}[\*\.\-\s]){4}|(\d{4}[\*\.\-\s]){2})|\d{8}|\d{10}|\d{12}$/;
    const alphabetsRegex = /^[a-zA-Z ]+$/;

    let nameFlag,
      logoFlag,
      emailFlag = false;
    let {
      name,
      error_name,
      initialCounsellor,
      email,
      error_email,
      password,
      error_password,
      file,
      error_logo,
      qualifications,
      error_qualifications,
      phone,
      error_phone,
      price_usd,
      price_pkr,
      error_price_usd,
      error_price_pkr,
      focus,
      error_focus,
      projectsSelected,
      error_projects,
      languagesSelected,
      serviceTypeSelected,
      error_languages,
      error_service_type,
      selectedId,
      city,
      error_city,
      mode,
    } = this.state;
    if (name === "") {
      error_name = name === "" ? "Please enter name" : "";
      nameFlag = false;
    } else {
      nameFlag = true;
      error_name = "";
    }
    if (name !== "") {
      if (alphabetsRegex.test(name)) {
        error_name = "";
        nameFlag = true;
      } else {
        error_name = "Please enter valid name";
        nameFlag = false;
      }
    }
    if (email === "") {
      error_email = "Please enter email address";
      emailFlag = false;
    } else if (validationEmail(email)) {
      error_email = "";
      emailFlag = true;
    } else {
      error_email = "Please provide a valid email address";
      emailFlag = false;
    }
    if (file) {
      const allowedTypes = ["image/jpeg", "image/png"];
      if (!validateImageFileType(file, allowedTypes)) {
        error_logo = constants.INVALID_LOGO_ERROR_TXT;
        logoFlag = false;
      }
      else {
        logoFlag = true;
        error_logo = "";
      }
    } else if (file === "" && mode !== "edit") {
      error_logo =constants.SELECT_LOGO_ERROR_TXT;
      logoFlag = false;
    } else {
      logoFlag = true;
      error_logo = "";
    }
    error_phone = phoneRegex.test(phone)
      ? ""
      : "Please enter valid phone number";
    if (mode !== "edit")
      error_password =
        password === "" || password.length < 6
          ? "Ensure the password fields has at least 6 characters"
          : "";
    error_focus = focus === "" ? "Please provide focused areas " : "";
    error_qualifications =
      qualifications === "" ? "Please provide counsellor qualifications" : "";
    error_projects =
      projectsSelected === [] || projectsSelected === null || projectsSelected.length === 0
        ? "Please select projects for counsellor"
        : "";
    error_languages =
      languagesSelected === [] || languagesSelected === null || languagesSelected.length === 0
        ? "Please select languages for counsellor"
        : "";
    error_service_type = !serviceTypeSelected || Object.keys(serviceTypeSelected).length === 0 ? "Please select service type"  : "";
    error_city = city.trim() === "" ? "Please provide counsellor home city" : !isNaN(parseInt(city)) ? ' Please provide a valid home city' : '';
    error_price_usd =
      price_usd === "" || parseInt(price_usd) <= 0
        ? "Please provide a valid price for the counsellor"
        : "";
    error_price_pkr =
      price_pkr === "" || parseInt(price_pkr) <= 0
        ? "Please provide a valid price for the counsellor "
        : "";
    this.setState({
      error_name,
      error_email,
      error_password,
      error_logo,
      error_qualifications,
      error_phone,
      error_focus,
      error_projects,
      error_languages,
      error_service_type,
      error_city,
      error_price_usd,
      error_price_pkr,
    });

    return (
      nameFlag &&
      emailFlag &&
      logoFlag &&
      error_password === "" &&
      error_qualifications === "" &&
      error_phone === "" &&
      error_focus === "" &&
      error_projects === "" &&
      error_languages === "" &&
      error_service_type === "" &&
      error_city === "" &&
      error_price_usd === "" &&
      error_price_pkr === ""
    );
  };

  submitCounsellor = (e) => {
    const urlRegex =
      /^(https?|ftp|torrent|image|irc):\/\/(-\.)?([^\s\/?\.#-]+\.?)+(\/[^\s]*)?$/i;
    e.preventDefault();

    const {
      name,
      initialCounsellor,
      email,
      password,
      file,
      qualifications,
      phone,
      focus,
      price_usd,
      price_pkr,
      projectsSelected,
      selectedId,
      city,
      mode,
      languages,
      languagesSelected,
      serviceTypeSelected,
    } = this.state;

    if (this.validate()) {
      let initialProjects =
        mode === "edit" ? initialCounsellor.project_details : [];

      let projects = [];

      if (projectsSelected.length > 0) {
        projectsSelected.map((p) => {
          if (mode === "edit") {
            if (initialProjects.filter((i) => i.id === p.value).length > 0)
              initialProjects.splice(
                initialProjects.findIndex((v) => v.id === p.value),
                1
              );
            return projects.push({ id: p.value, status: "True" });
          } else return projects.push(p.value);
        });
      }

      //languages object for payload
      let langs = [];
      if (languagesSelected.length > 0) {
        languagesSelected.map((l) => {
          return langs.push(l.value);
        });
      }
      if (mode === "edit" && initialProjects.length > 0) {
        initialProjects.map((i) => {
          return projects.push({ id: i.id, status: "False" });
        });
      }

      let fd = new FormData();
      if (!initialCounsellor || initialCounsellor === "") {
        fd.append("full_name", name.toString());
        fd.append("email_address", email.toString());
        fd.append("password", password.toString());
        fd.append("qualifications", qualifications.toString());
        fd.append("home_city", city);
        fd.append("contact_number", phone.toString());
        fd.append("picture", file);
        fd.append("area_of_expertise", focus.toString());
        fd.append("price_usd", price_usd === "" ? 0 : price_usd);
        fd.append("price_pkr", price_pkr === "" ? 0 : price_pkr);
        fd.append("is_available", "True");
        fd.append("projects", projects.join(","));
        fd.append("languages", langs.join(","));
        fd.append("service_type", serviceTypeSelected.value);
      } else {
        if (initialCounsellor.name !== name)
          fd.append("full_name", name.toString());
        if (initialCounsellor.qualifications !== qualifications)
          fd.append("qualifications", qualifications.toString());
        if (initialCounsellor.city !== city)
          fd.append("home_city", city.toString());
        if (initialCounsellor.phone !== phone)
          fd.append("contact_number", phone.toString());
        if (file) fd.append("picture", file);
        if (initialCounsellor.focus !== focus)
          fd.append("area_of_expertise", focus);
        if (initialCounsellor.price_usd !== price_usd)
          fd.append("price_usd", price_usd);
        if (initialCounsellor.price_pkr !== price_pkr)
          fd.append("price_pkr", price_pkr);
        if (initialCounsellor.projects !== projects)
          fd.append("projects", JSON.stringify(projects));
        if (initialCounsellor.counsellor_details.languages.join(",") !== langs.join(","))
          fd.append("languages", langs.join(","));
        if (
          initialCounsellor.counsellor_details.service_type !==
          serviceTypeSelected.label
        )
          fd.append("service_type",serviceTypeSelected.value);
      }
      this.toggleLoading(true);
      this.props.saveCounsellor(fd, selectedId);
    }
  };

  componentWillUnmount() {
    this.props.resetCounsellor();
  }

  cancel = () => {
    const { mode } = this.state;
    if (mode === "edit") history.push("/counsellors");
    else history.push("/home");
  };

  render() {
    const { alert } = this.props;
    const {
      file,
      error_logo,
      name,
      error_name,
      email,
      error_email,
      phone,
      error_phone,
      focus,
      error_focus,
      price_usd,
      price_pkr,
      error_price_usd,
      error_price_pkr,
      qualifications,
      error_qualifications,
      city,
      error_city,
      projectsSelected,
      error_projects,
      password,
      error_password,
      mode,
      initialCounsellor,
      projects,
      loading,
      languages,
      serviceTypes,
      languagesSelected,
      serviceTypeSelected,
      error_languages,
      error_service_type,
      langs,
    } = this.state;

    let optionsProjects = [];
    if (projects && projects.length > 0) {
      projects.map((w) => {
        return optionsProjects.push({ value: w.id, label: w.name });
      });
    }

    let optionServiceType = []
    let optionsLangs = [];
    if (serviceTypes && serviceTypes.length > 0) {
      serviceTypes.map((typ) => {
        return optionServiceType.push({ value: typ.id, label: typ.name });
      });
    }
    if (languages && languages.length > 0) {
      languages.map((w) => {
        return optionsLangs.push({ value: w.id, label: w.language });
      });
    }
    const fileLabel = file instanceof File
    ? file.name
    : mode === "edit" && initialCounsellor !== ""
      ? initialCounsellor.counsellor_details.picture.replace(/^.*[\\\/]/, "")
      : "Choose file"

    if (this.props.loading) return <Loading />;
    else {
      return (
        <div className="ContainerFix">
          <HeaderComponent />
          <Spring
            from={{ transform: "translate(+100%, 0)" }}
            to={{ transform: "translate(0%, 0)" }}
          >
            {(props) => (
              <div className="" style={props}>
                <div
                  className="row mt-5 mx-auto w-75 pb-5"
                  id="cardButtonContainer"
                >
                  {/* HEADING CONTAINER STARTS HERE */}
                  <div className="heading-container">
                    <p className="lead heading-line">{constants.COUNSELLORS}</p>
                    <p className="lead heading-text">
                      {mode === "edit"
                        ? "Update Counsellor"
                        : "Create Counsellor"}
                    </p>
                    <hr className="lead--heading-line" />
                  </div>
                  {/* HEADING CONTAINER ENDS HERE */}
                  {/* FORM STARTS HERE */}
                  <form name="project-form" className="form-container">
                    {this.props.message && (
                      <div
                        className={`alert text-center alert-danger error-message`}
                        id="errorMessage"
                      >
                        {this.props.message}
                      </div>
                    )}
                    <div className="form-row">
                      <div className="form-group col-md-5 col">
                        <label htmlFor="inputname" className="label-text">
                          {constants.NAME_TXT}
                          <span className="input-required"> *</span>
                        </label>
                        <input
                          type="name"
                          required="required"
                          // disabled={mode === 'edit'}
                          className="form-control"
                          id="inputname"
                          placeholder={constants.NAME_PLACEHOLDER_TXT}
                          name="name"
                          onChange={this.changeHandler}
                          value={name}
                        />
                        {error_name.length > 0 && (
                          <span className="input-required">{error_name}</span>
                        )}
                      </div>

                      <div className="offset-md-2 custom-file col-md-5">
                        <p className="label-text">
                          {constants.UPLOAD_IMAGE_TXT}
                          <span className="input-required"> *</span>
                        </p>
                        <div className="input-group mb-3">
                          <input
                            type="file"
                            accept={[".jpg", ".png"]}
                            name="file"
                            onChange={this.changeHandler}
                            className="custom-file-input"
                            id="inputGroupFile01"
                          />
                          <label
                            className="custom-file-label"
                            htmlFor="inputGroupFile01"
                          >
                           {fileLabel}
                          </label>
                          {error_logo.length > 0 && (
                            <span className="input-required">{error_logo}</span>
                          )}
                        </div>
                      </div>

                      <div className="form-group col-md-5">
                        <label htmlFor="inputemail" className="label-text">
                          {constants.EMAIL_ADDRESS}
                          <span className="input-required">*</span>
                        </label>
                        <input
                          type="email"
                          disabled={mode === "edit"}
                          name="email"
                          className="form-control"
                          required="required"
                          id="inputemail"
                          placeholder={constants.EMAIL_PLACEHOLDER_TXT}
                          onChange={this.changeHandler}
                          value={email}
                        />
                        {error_email.length > 0 && (
                          <span className="input-required">{error_email}</span>
                        )}
                      </div>
                      {mode !== "edit" ? (
                        <div className="offset-md-2 form-group col-md-5">
                          <label htmlFor="inputphone" className="label-text">
                            {constants.PASSWORD}
                            <span className="input-required"> *</span>
                          </label>
                          <input
                            type="password"
                            className="form-control"
                            id="inputpassword"
                            placeholder={constants.PASSWORD_PLACEHOLDER_TXT}
                            name="password"
                            value={password}
                            onChange={this.changeHandler}
                          />
                          {error_password.length > 0 && (
                            <span className="input-required">
                              {error_password}
                            </span>
                          )}
                        </div>
                      ) : (
                        <div className="offset-md-2 form-group col-md-5"></div>
                      )}
                      <div className="form-group col-md-5">
                        <label htmlFor="inputphone" className="label-text">
                          {constants.PHONE_TXT}
                          <span className="input-required"> *</span>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="inputphone"
                          placeholder={constants.PHONE_PLACEHOLDER_TXT}
                          name="phone"
                          value={phone}
                          onChange={this.changeHandler}
                        />
                        {error_phone.length > 0 && (
                          <span className="input-required">{error_phone}</span>
                        )}
                      </div>

                      <div className="offset-md-2 form-group col-md-5">
                        <label
                          htmlFor="inputrelationship"
                          className="label-text"
                        >
                          {constants.RELATION_WITH_WHITELABEL_TXT}
                          <span className="input-required"> *</span>
                        </label>

                        <Select
                          value={projectsSelected}
                          isMulti
                          name="projectsSelected"
                          options={optionsProjects}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          onChange={this.changeProjects}
                        />
                        {error_projects.length > 0 && (
                          <span className="input-required">
                            {error_projects}
                          </span>
                        )}
                      </div>

                      <div className="form-group col-md-5">
                        <label
                          htmlFor="inputqualification"
                          className="label-text"
                        >
                          {constants.QUALIFICATION_TXT}
                          <span className="input-required"> *</span>
                        </label>
                        <textarea
                          rows={3}
                          className="form-control"
                          id="inputqualification"
                          placeholder={constants.ENTER_QUALIFICATIONS_TXT}
                          name="qualifications"
                          onChange={this.changeHandler}
                          value={qualifications}
                        />
                        {error_qualifications.length > 0 && (
                          <span className="input-required">
                            {error_qualifications}
                          </span>
                        )}
                      </div>

                      <div className="offset-md-2 form-group col-md-5">
                        <label htmlFor="inputexpertarea" className="label-text">
                          {constants.AREA_OF_FOCUS_TXT}
                          <span className="input-required"> *</span>
                        </label>
                        <textarea
                          rows={3}
                          name="focus"
                          className="form-control"
                          id="inputexpertarea"
                          placeholder={constants.AREA_OF_FOCUS_PLACEHOLDER_TXT}
                          onChange={this.changeHandler}
                          value={focus}
                        />
                        {error_focus.length > 0 && (
                          <span className="input-required">{error_focus}</span>
                        )}
                      </div>
                      <div className="form-group col-md-5">
                        <label htmlFor="inputprice" className="label-text">
                          {constants.PRICE_USD_TXT}
                          <span className="input-required"> *</span>
                        </label>
                        <input
                          type="number"
                          name="price_usd"
                          className="form-control"
                          id="inputprice"
                          placeholder={constants.PRICE_PLACEHOLDER_TXT}
                          defaultValue={price_usd}
                          min={1}
                          onChange={this.changeHandler}
                        />
                        {error_price_usd.length > 0 && (
                          <span className="input-required">
                            {error_price_usd}
                          </span>
                        )}
                      </div>
                      <div className="offset-md-2 form-group col-md-5">
                        <label htmlFor="inputprice" className="label-text">
                          {constants.PRICE_PKR_TXT}
                          <span className="input-required"> *</span>
                        </label>
                        <input
                          type="number"
                          name="price_pkr"
                          className="form-control"
                          id="inputprice"
                          placeholder={constants.PRICE_PLACEHOLDER_TXT}
                          defaultValue={price_pkr}
                          min={1}
                          onChange={this.changeHandler}
                        />
                        {error_price_pkr.length > 0 && (
                          <span className="input-required">
                            {error_price_pkr}
                          </span>
                        )}
                      </div>
                      <div className="form-group col-md-5">
                        <label htmlFor="inputexpertarea" className="label-text">
                          {constants.HOME_CITY_TXT}
                          <span className="input-required"> *</span>
                        </label>
                        <input
                          type="text"
                          name="city"
                          className="form-control"
                          id="inputcity"
                          placeholder={constants.HOME_CITY_PLACEHOLDER_TXT}
                          onChange={this.changeHandler}
                          value={city}
                        />
                        {error_city.length > 0 && (
                          <span className="input-required">{error_city}</span>
                        )}
                      </div>
                      <div className="offset-md-2 form-group col-md-5">
                        <label
                          htmlFor="languagesSelected"
                          className="label-text"
                        >
                          {constants.LANGUAGES_TXT}
                          <span className="input-required"> *</span>
                        </label>
                        <Select
                          value={languagesSelected}
                          isMulti
                          name="languagesSelected"
                          options={optionsLangs}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          onChange={this.changeLanguages}
                        />
                        {error_languages.length > 0 && (
                          <span className="input-required">
                            {error_languages}
                          </span>
                        )}
                      </div>
                      <div className="form-group col-md-5">
                        <label
                          htmlFor="serviceTypeSelected"
                          className="label-text"
                        >
                          {constants.SELECT_SERVICE_TYPE_TXT}
                          <span className="input-required"> *</span>
                        </label>
                        <Select
                          value={Object.keys(serviceTypeSelected).length > 0 ? serviceTypeSelected : ''}
                          name="serviceTypeSelected"
                          options={optionServiceType}
                          className="basic-multi-select"
                          // classNamePrefix="select"
                          onChange={this.changeServiceType}
                          isDisabled={mode === 'edit'}
                        />
                        {error_service_type.length > 0 && (
                          <span className="input-required">
                            {error_service_type}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="marginTop25 textAlignCenter">
                      <button
                        className="cancel-submit-button"
                        onClick={this.cancel}
                      >
                        {constants.CANCEL_TXT}
                      </button>
                      <button
                        type="button"
                        className="appintment-submit-button"
                        onClick={this.submitCounsellor}
                      >
                        {mode === constants.CREATE_TXT.toLowerCase()
                          ? constants.CREATE_TXT
                          : constants.SAVE_TXT}
                      </button>
                    </div>
                  </form>{" "}
                  {/* FORM ENDS HERE */}
                </div>
              </div>
            )}
          </Spring>
          <Footer />
        </div>
      );
    }
  }
}
function mapStateToProps(state) {
  const { alert, languages, serviceTypes } = state;
  const authstate = state.auth;
  const { selectedCounsellor, counsellors, loading, message } =
    state.counsellors;
  const { whitelabel } = state.whitelabel;
  
  return {
    alert,
    authstate,
    counsellors,
    selectedCounsellor,
    whitelabel,
    loading,
    message,
    languages,
    serviceTypes
  };
}

function mapDispatchToProps(dispatch) {
  return {
    saveCounsellor: (obj, id) => {
      dispatch(CounsellorsActions.saveCounsellor(obj, id));
    },
    resetCounsellor: () => {
      dispatch(CounsellorsActions.resetCounsellor());
    },
    fetchCounsellors: () => {
      dispatch(CounsellorsActions.fetchCounsellors());
    },
    fetchWhitelabel: () => {
      dispatch(WhitelabelActions.fetchWhitelabel());
    },
    clearAlertActions: () => {
      dispatch(alertActions.clear());
    },
    alertError: (message) => {
      dispatch(alertActions.error(message));
    },
    fetchLanguages: () => {
      dispatch(LanguagesActions.fetchLanguages());
    },
    fetchServiceType: () => {
      dispatch(serviceTypeActions.fetchServiceType());
    },
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CreateCounsellor)
);



// WEBPACK FOOTER //
// ./src/screens/CreateCounsellor/index.js